// extracted by mini-css-extract-plugin
export default {"bar":"Announcement_bar__YvKa0","message":"Announcement_message__qfDPR","close":"Announcement_close__+CQjB"};